import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)
const routes = [{
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path:"/correspondence",
    naem:"correspondence",
    component:() => import('./views/Correspondence.vue')
  },
  {
    path:"/communicate",
    name:"communicate",
    component:() => import('./views/Communicate.vue')
  },
  {
    // 入箱扫码 组件
    path:"/inboundScanning",
    name:'inboundScanning',
    component:() => import('./views/InboundScanning.vue')
  },
  {
    // 待出箱扫码 组件
    path:"/outBoxList",
    name:"outBoxList",
    component:() => import('./views/outBoxList,.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( /* webpackChunkName: "about" */ './views/About.vue')
  },
  {
    path: '/',
    name: 'loginPage',
    component: () => import('./views/loginPage.vue')
  },
  {
    path: "/RscOutInfo",
    // Rsc 出库单
    name: "RscOutInfo",
    component: () => import("./views/RscOutInfo.vue")
  },
  {
    path: "/RscWarehousing",
    // Rsc 入库单
    name: "RscWarehousing",
    component: () => import("./views/RscWarehousing.vue")
  },
  {
    path: '/selectData',
    name: 'selectData',
    component: () => import('./views/selectData.vue')
  },
  {
    path: '/orderInfo',
    name: 'orderInfo',
    component: () => import('./views/orderInfo.vue')
  },
  {
    path: '/fillingGoods',
    name: 'fillingGoods',
    component: () => import('./views/fillingGoods.vue')
  },
  {
    path: '/FGlist',
    name: 'FGlist',
    component: () => import('./views/FGlist.vue')
  },
  {
    path: '/FGlistInfo',
    name: 'FGlistInfo',
    component: () => import('./views/FGlistInfo.vue')
  },
  {
    path: '/FGscan',
    name: 'FGscan',
    component: () => import('./views/FGscan.vue')
  },
  {
    path: '/codeSelect',
    name: 'codeSelect',
    component: () => import('./views/codeSelect.vue')
  },
  {
    path: '/outlist',
    name: 'outlist',
    component: () => import('./views/outlist.vue')
  },
  {
    path: '/allout',
    name: 'allout',
    component: () => import('./views/allout.vue')
  },
  {
    path: '/numberOut',
    name: 'numberOut',
    component: () => import('./views/numberOut.vue')
  },
  {
    path: '/cleanOutInfo',
    name: 'cleanOutInfo',
    component: () => import('./views/cleanOutInfo.vue')
  },
  {
    path: '/cleanOutlist',
    name: 'cleanOutlist',
    component: () => import('./views/cleanOutlist.vue')
  },
  {
    path: "/weightOutInfo",
    name: "weightOutInfo",
    component: () => import("./views/WeightOutInfo.vue")
  },
  {
    path: "/directOutbound",
    name: "directOutbound",
    component: () => import("./views/DirectOutbound.vue")
  },
  {
    path: "/WarehouseStocking",//卷号出入仓
    name: "WarehouseStocking",
    component: () => import("./views/WarehouseStocking.vue")
  },
  {
    path: "/WarehouseOutbound",//明细码和货号出仓
    name: "WarehouseOutbound",
    component: () => import("./views/WarehouseOutbound.vue")
  },
  {
    path: "/FabricAdjustment",//布匹调整
    name: "FabricAdjustment",
    component: () => import("./views/FabricAdjustment.vue")
  },
  {
    path: "/NewFabricStock-in",//新建布匹入库
    name: "NewFabricStock-in",
    component: () => import("./views/NewFabricStock-in.vue")
  },
  {
    path: "/ReturnWarehouse",//新建退货单
    name: "ReturnWarehouse",
    component: () => import("./views/ReturnWarehouse.vue")
  },
  {
    path: "/orderDetailsList",//订单明细列表FabricPicking
    name: "orderDetailsList",
    component: () => import("./views/orderDetailsList.vue")
  },
  {
    path: "/FabricPicking",//订单拣货
    name: "FabricPicking",
    component: () => import("./views/FabricPicking.vue")
  },
  {
    path: "/FabricOutList",//面料出库表
    name: "FabricOutList",
    component: () => import("./views/FabricOutList.vue")
  },
  {
    path: "/FabricOutDetail",//面料出库详情
    name: "FabricOutDetail",
    component: () => import("./views/FabricOutDetail.vue")
  },
  {
    path: "/FabricInventory",//布匹盘点
    name: "FabricInventory",
    component: () => import("./views/FabricInventory.vue")
  },
  {
    path: "/bluetoothLink",//蓝牙地址链接 
    name: "bluetoothLink",
    component: () => import("./views/bluetoothLink.vue")
  },
    {
    path: "/cards",//计件
    name: "cards",
    component: () => import("./views/cards.vue")
  },
  {
    path: "/GoodsPut",//货位上架 
    name: "GoodsPut",
    component: () => import("./views/GoodsPut.vue")
  },
  {
    path: "/NumberFind",//货号查询
    name: "NumberFind",
    component: () => import("./views/NumberFind.vue")
  },
  {
    path: "/Reelcrop",//裁切 
    name: "Reelcrop",
    component: () => import("./views/Reelcrop.vue")
  },
  {
    path: "/OrderIn",//裁切 
    name: "OrderIn",
    component: () => import("./views/OrderIn.vue")
  },
  {
    path: "/OutPicking",//出库装箱 
    name: "OutPicking",
    component: () => import("./views/OutPicking.vue")
  },
  {
    path: "/Finished-in",//成品入库（瑞动）
    name: "Finished-in",
    component: () => import("./views/Finished-in.vue")
  },
  {
    path: "/Finished-out",//成品出库（瑞动）
    name: "Finished-out",
    component: () => import("./views/Finished-out.vue")
  },
  {
    path: "/Finished-in-B",//半成品入库（瑞动）
    name: "Finished-in-B",
    component: () => import("./views/Finished-in-B.vue")
  },
  {
    path: "/Finished-out-B",//半成品出库（瑞动）
    name: "Finished-out-B",
    component: () => import("./views/Finished-out-B.vue")
  },
  {
    path: "/allocation",//货位调拨（瑞动）
    name: "allocation",
    component: () => import("./views/allocation.vue")
  }
]
const router = new Router({
  routes
})

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (to.path === '/' || to.name === 'codeSelect' || to.name === "fillingGoods") {
    next()
  } else if (localStorage.getItem('userinfo') !== 'undefined' && localStorage.getItem('userinfo') !== null) { // 判断是否登录
    next()
  } else { // 没登录则跳转到登录界面
    next({
      path: '/',
    })
  }
})
export default router